import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, Container, Row, Col, Card, CardBody } from "reactstrap";

const LoginPage = () => {
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        navigate("/stats");
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Row className="w-100 justify-content-center">
                <Col md={6} lg={4}>
                    <Card className="shadow">
                        <CardBody>
                            <h3 className="text-center mb-4">Вход</h3>
                            <Form onSubmit={handleLogin}>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input type="email" id="email" placeholder="Введите email"  /> {/*required*/}
                                </FormGroup>
                                <FormGroup>
                                    <Label for="password">Пароль</Label>
                                    <Input type="password" id="password" placeholder="Введите пароль" /> {/*required*/}
                                </FormGroup>
                                <Button color="primary" type="submit" className="w-100 mt-3">Войти</Button>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginPage;
